export const SET_PIPELINE = "SET_PIPELINE";
export const SET_PIPELINE_TRIGGER = "SET_PIPELINE_TRIGGER";
export const SET_PIPELINE_SINGLE = "SET_PIPELINE_SINGLE";
export const SET_PIPELINE_DATA = "SET_PIPELINE_DATA";
export const DELETE_PIPELINE_DATA = "DELETE_PIPELINE_DATA";
export const PIPELINE_OPTIONS = "PIPELINE_OPTIONS";
export const SET_FIELD = "SET_FIELD";
